import styles from "./closeButton.module.css";

function CloseButton({ onClick }: { onClick: () => void }) {
  return <button className={`${styles.closeBtn} hover`} onClick={onClick} />;
}

export default CloseButton;
